module.exports = __webpack_public_path__ + "static/img/daiyunying_shouhou.f37694d7.png";